module.exports = __webpack_public_path__ + "static/media/ios-done-all.bd421527.svg";